<template>
  <div class="appApplicaton-content-icon">
    <el-upload
      :accept="property.accept"
      :limit="1"
      action=""
      drag
      :http-request="submitIcon"
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :before-upload="beforeAvatarUpload"
      :file-list="fileList"
      :disabled="property.disabled"
    >
      <i class="image-icon el-icon-plus" />
    </el-upload>
    <el-dialog :visible.sync="imgDialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "UploadImg",
  props: {
    property: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      fileList: [],
      dialogImageUrl: "",
      imgDialogVisible: false
    };
  },
  mounted() {
    this.fileList = [];
    if (this.property.url) {
      this.fileList.push({ url: this.property.url });
    }
  },
  methods: {
    // 上传图片
    submitIcon(fileObj) {
      this.fileList = [];
      const { file } = fileObj;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.fileList.push({ url: reader.result });
        this.$emit("change", file);
      };
    },
    // 删除该图片按钮
    handleRemove(file, fileList) {
      this.$emit("remove");
    },
    // 放大图片按钮
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    // 判断是否图片大小
    beforeAvatarUpload(file) {
      const isLt = file.size / 1024 > this.property.limit;
      if (isLt) {
        this.$message.warning(`上传图片大小不能超过${this.property.limit}kb`);
        return false;
      }
      let flag = 0;
      this.property.accept.split(",").forEach(val => {
        if (file.name.includes(val)) {
          flag++;
        }
      });
      if (!flag) {
        this.$message.warning(`请选择jpg，jpeg，png格式的图片`);
      }
      return Boolean(flag);
    }
  }
};
</script>

<style lang="scss">
.appApplicaton-content-icon {
  cursor: pointer;
  width: 100px;
  height: 100px;
  background: #fff;
  border: 1px dashed #c6ccd7;
  overflow: hidden;
  & > div {
    width: 100%;
    height: 100%;
  }
  .el-upload-dragger {
    background: #fff;
    width: 100%;
    height: 100%;
    border: 0;
  }
  .el-upload--picture-card {
    width: 100% !important;
    height: 100% !important;
    border: 0;
    border-radius: 0;
    background-color: #fff;
    position: relative;
  }
  .el-upload-list--picture-card {
    .el-upload-list__item {
      width: 100%;
      height: 100%;
    }
  }
  .el-upload-list {
    .el-upload-list__item {
      width: 100%;
      height: 100%;
      border: 0;
      transition: none;
      width: 100px !important;
      height: 100px !important
    }
  }
  .el-upload-list__item-actions {
    background-color: rgba(33, 37, 46, 0.5) !important;
    border-radius: 0 !important;
  }
  .el-upload-list__item {
    border-radius: 0 !important;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
  .el-upload-list__item-thumbnail {
    max-width: 100%;
    max-height: 100%;
    width: auto !important;
    height: auto !important;
  }
  .el-upload-list__item-status-label {
    display: none !important;
  }
  .image-icon {
    font-size: 22px !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
